import { IFileData } from "../CreateFeeSchedule";

export const generateRulesetList = ({
  providers,
  payers,
  data,
}: {
  providers: { name: string; value: string }[];
  payers: { name: string; value: number }[];
  data: IFileData[];
}) => {
  const result = [] as any[];
  const providerIds = providers.map((provider) => provider.value);
  const payerIds = payers.map((payer) => payer.value);

  providerIds.forEach((providerId) => {
    payerIds.forEach((payerId) => {
      const newObj = {
        providerId,
        payerId,
        data,
      };
      result.push(newObj);
    });
  });
  return result;
};
